// Standardizovaný výstup vlastností objektu (§10). Tvar výstupu je nezávislý na
// interním formátu IFC knihoven — hostitel dostává vždy stejné schéma:
// { globalId, ifcClass, name, description, attributes, propertySets, quantities, classification }
import * as OBC from "@thatopen/components";

function val(v) {
  if (v === null || v === undefined) return null;
  if (typeof v === "object") return "value" in v ? (v.value == null ? null : v.value) : null;
  return v;
}
function ifcClassOf(attrs) {
  if (!attrs) return null;
  return OBC.IfcCategoryMap[attrs.type] || (attrs.type != null ? "Type" + attrs.type : null);
}

// Vytáhne jednu hodnotu z IfcProperty (různé *Value varianty) nebo IfcQuantity.
function propValue(prop) {
  return val(prop.NominalValue) ?? val(prop.LengthValue) ?? val(prop.AreaValue)
      ?? val(prop.VolumeValue) ?? val(prop.CountValue) ?? val(prop.WeightValue)
      ?? val(prop.TimeValue) ?? val(prop.Value) ?? null;
}

// Načte kompletní standardizované vlastnosti pro (model, expressID).
export async function extractProperties(core, model, expressID, globalId) {
  const group = model.group;
  const attrs = await group.getProperties(expressID);
  if (!attrs) return null;

  const out = {
    modelId: model.modelId,
    globalId: globalId || (attrs.GlobalId ? val(attrs.GlobalId) : null),
    expressId: expressID,
    ifcClass: ifcClassOf(attrs),
    name: val(attrs.Name),
    description: val(attrs.Description),
    objectType: val(attrs.ObjectType),
    predefinedType: val(attrs.PredefinedType),
    attributes: {},
    propertySets: {},
    quantities: {},
    classification: [],
  };

  for (const [k, v] of Object.entries(attrs)) {
    if (k === "type" || k === "expressID") continue;
    const value = val(v);
    if (value !== null && value !== "") out.attributes[k] = value;
  }

  try {
    const defIDs = core.indexer.getEntityRelations(group, expressID, "IsDefinedBy") || [];
    for (const pid of defIDs) {
      const pset = await group.getProperties(pid);
      if (!pset) continue;
      const psetName = val(pset.Name) || "Pset";
      const refs = pset.HasProperties || pset.Quantities || [];
      if (!refs.length) continue;
      const isQuantity = !!pset.Quantities;
      const bucket = {};
      for (const ref of refs) {
        const prop = await group.getProperties(ref.value);
        if (!prop) continue;
        const pn = val(prop.Name);
        if (pn == null) continue;
        bucket[pn] = propValue(prop);
      }
      if (isQuantity) out.quantities[psetName] = bucket;
      else out.propertySets[psetName] = bucket;
    }
  } catch (_) { /* psety/quantities best-effort */ }

  try {
    const clsIDs = core.indexer.getEntityRelations(group, expressID, "HasAssociations") || [];
    for (const cid of clsIDs) {
      const assoc = await group.getProperties(cid);
      if (!assoc) continue;
      const ref = assoc.RelatingClassification ? await group.getProperties(assoc.RelatingClassification.value) : null;
      out.classification.push({
        system: ref ? val(ref.Name) : val(assoc.Name),
        identification: val(assoc.Identification) || val(assoc.ItemReference),
        name: val(assoc.Name),
      });
    }
  } catch (_) { /* klasifikace best-effort */ }

  return out;
}
